"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBanner = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _CategoryBar = require("../CategoryBar");
var _TopBannerBreadcrumbs = require("./TopBannerBreadcrumbs");
var _TopBannerImage = require("./TopBannerImage");
var _TopBannerTitle = require("./TopBannerTitle");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component for displaying content on top of a page. It contains some background, title and breadcrumbs.
 * Must have specified at least `backgroundColor` or `imageUrl` or `title` or `breadcrumbs. Otherwise component returns `null`.
 */
const TopBanner = ({
  backgroundColor,
  breadcrumbs,
  categoryBarProps,
  className,
  imageUrl,
  textColor,
  title,
  extraLongHeadline
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!backgroundColor && !imageUrl && !title) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TopBannerBreadcrumbs.TopBannerBreadcrumbs, {
        renderSeparately: true,
        breadcrumbs: breadcrumbs
      }), categoryBarProps ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CategoryBar.CategoryBar, {
        ...categoryBarProps
      }) : null]
    });
  }
  const isImagePresent = !!imageUrl;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      backgroundColor: backgroundColor,
      className: className,
      "data-testid": getTestId(_constants.TOP_BANNER),
      showBackground: isImagePresent,
      textColor: textColor,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TopBannerBreadcrumbs.TopBannerBreadcrumbs, {
        breadcrumbs: breadcrumbs,
        renderSeparately: isImagePresent
      }), isImagePresent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopBannerImage.TopBannerImage, {
        backgroundColor: backgroundColor,
        imageUrl: imageUrl,
        title: title
      }) : null, isImagePresent && categoryBarProps ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CategoryBar.CategoryBar, {
        ...categoryBarProps
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopBannerTitle.TopBannerTitle, {
        imageUrl: imageUrl,
        hasBreadcrumbs: !!breadcrumbs && breadcrumbs.length > 0,
        title: title,
        extraLongHeadline: extraLongHeadline
      })]
    }), !isImagePresent && categoryBarProps ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CategoryBar.CategoryBar, {
      ...categoryBarProps
    }) : null]
  });
};
exports.TopBanner = TopBanner;
